import { render, staticRenderFns } from "./IconRecent.vue?vue&type=template&id=6456d3a1&"
import script from "./IconRecent.vue?vue&type=script&lang=js&"
export * from "./IconRecent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6456d3a1')) {
      api.createRecord('6456d3a1', component.options)
    } else {
      api.reload('6456d3a1', component.options)
    }
    module.hot.accept("./IconRecent.vue?vue&type=template&id=6456d3a1&", function () {
      api.rerender('6456d3a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconRecent.vue"
export default component.exports